import { http, createConfig } from 'wagmi';
import { baseSepolia, base } from 'wagmi/chains';
import { injected, coinbaseWallet, walletConnect } from 'wagmi/connectors';
import { CHAIN } from '../config/chain';

/** WalletConnect option is hidden when no project id is configured. */
export const WC_PROJECT_ID: string = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || '';

export const ACTIVE_CHAIN = CHAIN.key === 'base' ? base : baseSepolia;

const appMeta = {
  name: 'No Tomorrow 3D',
  description: 'Buy a key, add 30s, last buyer wins. Testnet demo.',
  url: typeof window !== 'undefined' ? window.location.origin : 'https://nt3d.fun',
  icons: [typeof window !== 'undefined' ? window.location.origin + '/icon-192.svg' : ''],
};

const connectors = [
  injected({ shimDisconnect: true }),
  coinbaseWallet({ appName: appMeta.name, appLogoUrl: appMeta.icons[0], preference: 'smartWalletOnly' }),
  ...(WC_PROJECT_ID ? [walletConnect({ projectId: WC_PROJECT_ID, showQrModal: true, metadata: appMeta })] : []),
];

export const wagmiConfig = createConfig({
  chains: [ACTIVE_CHAIN],
  // EIP-6963: every installed browser wallet shows up as its own connector (the multi-wallet picker)
  multiInjectedProviderDiscovery: true,
  connectors,
  transports: { [ACTIVE_CHAIN.id]: http(CHAIN.rpcUrl || undefined) } as any,
});

declare module 'wagmi' {
  interface Register { config: typeof wagmiConfig }
}
